import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CartService } from '../../../../shared/services/cart.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-cart-section',
  templateUrl: './cart-section.component.html',
  styleUrls: ['./cart-section.component.scss']
})
export class CartSectionComponent implements OnInit {
  @Input() showCart: boolean = false;
  cartItems: any[] = [];
  @Output() closeCart = new EventEmitter<void>();
  @Output() placeOrder = new EventEmitter<any>();

  showOrderModal: boolean = false;
  orderTotal: number = 0;
  totalQuantity:number = 0;
  showCheckout = false;
  orderData: any;

  constructor(private cartService: CartService ,private router: Router) { }

  ngOnInit(): void {
    this.cartService.cartItems$.subscribe(items => {
      
      this.cartItems = items;
      console.log("cart items",this.cartItems)
      this.totalQuantity = this.calculateTotalQuantity();
    });
  }

  calculateTotal(): number {
    return this.cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  }

  closeCartPanel(): void {
    this.closeCart.emit();
  }

  openOrderModal(): void {
    this.orderTotal = this.calculateTotal();
    this.onPlaceOrder();
    // this.showCheckout = true;
    // this.openCheckout(data)();
  }

  closeOrderModal(): void {
    this.showCheckout = false;
  }

  // onPlaceOrder(): void {
  //   const isLoggedIn = localStorage.getItem('is_logged_in');

  //   // CHECK LOGIN
  //   if (!isLoggedIn) {
  //     // OPTIONAL MESSAGE
  //     alert('Please login to place your order');
  //     // REDIRECT TO LOGIN PAGE
  //     this.router.navigate(['/profile-authentication']);
  //     return;
  //   }
  //   this.placeOrder.emit({
  //     items: this.cartItems,
  //     total: this.orderTotal
  //   });
  //   // this.cartService.clearCart();
  //   this.closeOrderModal();
  //   this.closeCartPanel();
  // }

onPlaceOrder(): void {

  const isLoggedIn = localStorage.getItem('is_logged_in');

  /* CHECK LOGIN */
  if (!isLoggedIn) {

    alert('Please login to place your order');

    this.router.navigate(['/profile-authentication']);

    return;
  }

  /* SAVE ORDER DATA */
  this.orderData = {

    items: this.cartItems,

    total: this.orderTotal,

    totalQuantity: this.totalQuantity,

    orderDate: new Date()

  };

  console.log('Order Data:', this.orderData);

  /* OPEN CHECKOUT MODAL */
  this.showCheckout = true;
}

  removeItem(cart_item_id: number): void {
    this.cartService.removeFromCart(cart_item_id);
  }

  updateQuantity(cart_item_id: number, quantity: number): void {
    
    this.cartService.updateQuantity(cart_item_id, quantity);
  }

  calculateTotalQuantity(): number {
  // return this.cartItems.reduce((total, item) => total + item.quantity, 0);
   return this.cartItems.length;
}


  openCheckout(data: any) {
    this.orderData = data;
    this.showCheckout = true;
  }


}
